import Model from "./Model";

export default class ImageModel extends Model {
  id: number;
  url: string;
  source: any;
  resizeFactor: number;
  description: string;
  static __typename: string = "Image";

  constructor(image: any, getters: any) {
    super(getters);
    this.id = image.id;
    this.url = image.url;
    this.source = image.source;
    this.resizeFactor = image.resizeFactor || 100;
    this.description = image.description;
  }

  raw() {
    return {
      id: this.id,
      url: this.url,
      source: this.source,
      resizeFactor: this.resizeFactor,
      description: this.description,
      __typename: ImageModel.__typename
    };
  }
}